<script>
import { mapGetters } from 'vuex';
import { getBrandStripeConfig } from '../../../helper/brandStripeConfig';

export default {
  name: 'Knowledge',
  mounted() {
    const script = document.createElement('script');
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);
  },
  methods:{
    bypass(){
      this.$router.push({name: 'login'});
    }
  },
  computed: {
    ...mapGetters({
      currentAccountId: 'getCurrentAccountId',
      getAccount: 'accounts/getAccount',
    }),
    accountSource() {
      return this.getAccount(this.currentAccountId)?.custom_attributes?.account_source;
    },
    pricingTableId(){
      return getBrandStripeConfig(this.accountSource).pricingTableId;
    },
    publishableKey(){
      return getBrandStripeConfig(this.accountSource).publishableKey;
    },
  }
}
</script>

<template>
    <div class="w-full">
      <stripe-pricing-table
        :pricing-table-id="pricingTableId"
        :publishable-key="publishableKey"
      >
      </stripe-pricing-table>
    </div>
  </template>
